import { isSettingsSubSideNavPathname } from '~/utils/isSettingsSubSideNavPathname';
import { isSubSideNavPathname } from '~/utils/isSubSideNavPathname';

export const isSubSideNavOpen = (pathname: string, storeOpen: boolean) =>
  isSubSideNavPathname(pathname) && (storeOpen || isSettingsSubSideNavPathname(pathname));
